module.exports = __webpack_public_path__ + "static/img/img_02.4fef5a62.png";